import { useEffect, useState } from 'react';
import {
  ApplicationPickerItem,
  applicationPickerItems,
} from '../components/AppMenu/applicationPickerItems';
import useClient from './useClient';
import { listUserAccessesByUserId } from '#/tis/graphql';
import { APP_IDS } from '../constants/applications';
import useAuthToken from '#/common/hooks/useAuthToken';
import uniq from 'lodash/uniq';

const DEFAULT_ITEMS = [
  APP_IDS.HOME,
  APP_IDS.TMM,
  'separator',
  APP_IDS.SETUP,
  APP_IDS.ACCOUNT_SETTINGS,
]
  .map((a) =>
    applicationPickerItems.find((item) =>
      item === 'separator' ? a === 'separator' : item.id === a,
    ),
  )
  .filter((a): a is ApplicationPickerItem => !!a);

const useApplicationPickerItems = (): ApplicationPickerItem[] => {
  const [items, setItems] = useState<ApplicationPickerItem[]>([]);

  const client = useClient();
  const token = useAuthToken();
  const userId = token?.uId;

  useEffect(() => {
    if (!client || !userId) {
      console.error('No Client or UserID!', { client, userId });
      setItems(DEFAULT_ITEMS);
      return;
    }

    client
      .query({
        query: listUserAccessesByUserId,
        variables: { userId },
      })
      .then(({ data }) => {
        const appIds = uniq(data.listUserAccessesByUserId?.items?.map((item) => item.appId));

        const result = applicationPickerItems.filter(
          (item) => item === 'separator' || item.alwaysVisible || appIds.includes(item.id),
        );

        setItems(result);
      })
      .catch((error) => {
        console.error('Failed to fetch application picker items.', error);
        setItems(DEFAULT_ITEMS);
      });
  }, [userId, client]);

  return items;
};

export default useApplicationPickerItems;
